/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any };
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: number; output: number };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any };
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION',
}

export type AvailabilityDetail = {
  __typename?: 'AvailabilityDetail';
  currency: Scalars['String']['output'];
  disEmbarkationDate: Scalars['String']['output'];
  embarkationDate: Scalars['String']['output'];
  numberOfDay: Scalars['Int']['output'];
  numberOfDive: Scalars['Int']['output'];
  numberOfNight: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  routeId: Scalars['Int']['output'];
  routeName: Scalars['String']['output'];
  totalAvailability: Scalars['Int']['output'];
  tripId: Scalars['Int']['output'];
};

export type Boat = {
  __typename?: 'Boat';
  boatId: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type BoatFacility = {
  __typename?: 'BoatFacility';
  boatId: Scalars['Int']['output'];
  facilityGroupId: Scalars['Int']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
};

export type BoatPhoto = {
  __typename?: 'BoatPhoto';
  boatId: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isHero?: Maybe<Scalars['Boolean']['output']>;
};

export type Booking = {
  __typename?: 'Booking';
  bookingId: Scalars['Int']['output'];
  bookingState: Scalars['Int']['output'];
  tripId: Scalars['Int']['output'];
};

export type BookingCreateInput = {
  bookingState: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  existingBookingId?: InputMaybe<Scalars['Int']['input']>;
  fullName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  numberOfGuests: Scalars['Int']['input'];
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentOption: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  rooms: Array<RoomDetailInput>;
  tripId: Scalars['Int']['input'];
};

export type BookingRoom = {
  __typename?: 'BookingRoom';
  bookingId: Scalars['Int']['output'];
  numberOfRooms: Scalars['Int']['output'];
  pricePerRoom: Scalars['Decimal']['output'];
  typeId: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  countryId: Scalars['Int']['output'];
  countryName: Scalars['String']['output'];
};

export type CountryLandingData = {
  __typename?: 'CountryLandingData';
  boats: Array<LandingBoatSummary>;
  countryId: Scalars['Int']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  departureCount: Scalars['Int']['output'];
  maxPrice?: Maybe<Scalars['Decimal']['output']>;
  minPrice?: Maybe<Scalars['Decimal']['output']>;
  nextDepartureDate?: Maybe<Scalars['DateTime']['output']>;
  routes: Array<RouteLandingSummary>;
};

export type Coupon = {
  __typename?: 'Coupon';
  code: Scalars['String']['output'];
  couponId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountType: Scalars['String']['output'];
  discountValue: Scalars['Decimal']['output'];
  isActive: Scalars['Boolean']['output'];
  maxUsage: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  validFrom: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type CouponValidationInput = {
  boatId?: InputMaybe<Scalars['Int']['input']>;
  couponCode: Scalars['String']['input'];
  totalAmount: Scalars['Decimal']['input'];
  userId: Scalars['Int']['input'];
};

export type CouponValidationResult = {
  __typename?: 'CouponValidationResult';
  couponCode?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Decimal']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Decimal']['output']>;
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  newTotalAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type DeleteTripResponse = {
  __typename?: 'DeleteTripResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DiveCertificate = {
  __typename?: 'DiveCertificate';
  certificateId: Scalars['Int']['output'];
  certificateLevel?: Maybe<Scalars['String']['output']>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  certifyingAgency?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type DiveCertificateInput = {
  certificateId: Scalars['Int']['input'];
  certificateLevel?: InputMaybe<Scalars['String']['input']>;
  certificateNumber?: InputMaybe<Scalars['String']['input']>;
  certifyingAgency?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DiveEquipment = {
  __typename?: 'DiveEquipment';
  bcd?: Maybe<Scalars['String']['output']>;
  equipmentId: Scalars['Int']['output'];
  fins?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  wetsuit?: Maybe<Scalars['String']['output']>;
};

export type DiveEquipmentInput = {
  bcd?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['Int']['input'];
  fins?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  wetsuit?: InputMaybe<Scalars['String']['input']>;
};

export type DiveInsurance = {
  __typename?: 'DiveInsurance';
  insuranceId: Scalars['Int']['output'];
  policyNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type DiveInsuranceInput = {
  insuranceId: Scalars['Int']['input'];
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DiveSite = {
  __typename?: 'DiveSite';
  diveSiteId: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  siteName: Scalars['String']['output'];
};

export type FacilityGroup = {
  __typename?: 'FacilityGroup';
  facilityGroupId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FeatureTrip = {
  __typename?: 'FeatureTrip';
  boatId: Scalars['Int']['output'];
  boatName: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  disembarkationDate: Scalars['String']['output'];
  diveCount: Scalars['Int']['output'];
  embarkationDate: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  numberOfDays: Scalars['Int']['output'];
  numberOfNights: Scalars['Int']['output'];
  organizerId: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  routeId: Scalars['Int']['output'];
  routeName: Scalars['String']['output'];
  tripId: Scalars['Int']['output'];
};

export type GuestDetailsInput = {
  airportTransferNeeded: Scalars['Boolean']['input'];
  arrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalFlightNumber: Scalars['String']['input'];
  bookingId: Scalars['Int']['input'];
  certificateLevel: Scalars['String']['input'];
  certificateNumber: Scalars['String']['input'];
  certifyingAgency: Scalars['String']['input'];
  countryOfIssuance: Scalars['String']['input'];
  departureDate?: InputMaybe<Scalars['DateTime']['input']>;
  departureFlightNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emergencyContactName: Scalars['String']['input'];
  emergencyContactPhone: Scalars['String']['input'];
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  fullName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  guestNumber: Scalars['Int']['input'];
  passportNumber: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  rentalGear: Array<KeyValuePairOfStringAndRentalGearItemInput>;
  selfTransferUponArrival: Scalars['Boolean']['input'];
  selfTransferUponDeparture: Scalars['Boolean']['input'];
};

export type KeyValuePairOfStringAndRentalGearItemInput = {
  key: Scalars['String']['input'];
  value: RentalGearItemInput;
};

/** Schema extension for landing page queries (merged at codegen time). */
export type LandingBoatSummary = {
  __typename?: 'LandingBoatSummary';
  boatId: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  minPrice?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type MainRouteLandingData = {
  __typename?: 'MainRouteLandingData';
  boats: Array<LandingBoatSummary>;
  countryId: Scalars['Int']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  departureCount: Scalars['Int']['output'];
  mainRouteId: Scalars['Int']['output'];
  mainRouteName?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Scalars['Decimal']['output']>;
  minPrice?: Maybe<Scalars['Decimal']['output']>;
  nextDepartureDate?: Maybe<Scalars['DateTime']['output']>;
  routeImageUrl?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBooking: Booking;
  createPaymentIntent: PaymentIntentResponse;
  createUser: Scalars['Boolean']['output'];
  deleteTrip: DeleteTripResponse;
  guestDetail: Scalars['Boolean']['output'];
  tripInvite: Scalars['Boolean']['output'];
  updateTripAvailability: Scalars['Boolean']['output'];
  updateTripPrices: Scalars['Boolean']['output'];
  updateUser: Scalars['Boolean']['output'];
  upsertDiveCertification: Scalars['Boolean']['output'];
  upsertDiveEquipment: Scalars['Boolean']['output'];
  upsertDiveInsurance: Scalars['Boolean']['output'];
  upsertEmergencyContact: Scalars['Boolean']['output'];
  upsertTravelDocument: Scalars['Boolean']['output'];
  validateCoupon: CouponValidationResult;
};

export type MutationCreateBookingArgs = {
  input: BookingCreateInput;
};

export type MutationCreatePaymentIntentArgs = {
  input: PaymentIntentCreateInput;
};

export type MutationCreateUserArgs = {
  user: UserInput;
};

export type MutationDeleteTripArgs = {
  tripId: Scalars['Int']['input'];
};

export type MutationGuestDetailArgs = {
  guestDetails: GuestDetailsInput;
};

export type MutationTripInviteArgs = {
  bookingId: Scalars['Int']['input'];
  guestEmail: Scalars['String']['input'];
  guestNumber: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type MutationUpdateTripAvailabilityArgs = {
  input: UpdateTripAvailabilityInput;
};

export type MutationUpdateTripPricesArgs = {
  input: UpdateTripPricesInput;
};

export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};

export type MutationUpsertDiveCertificationArgs = {
  input: DiveCertificateInput;
};

export type MutationUpsertDiveEquipmentArgs = {
  input: DiveEquipmentInput;
};

export type MutationUpsertDiveInsuranceArgs = {
  input: DiveInsuranceInput;
};

export type MutationUpsertEmergencyContactArgs = {
  input: UserEmergencyContactInput;
};

export type MutationUpsertTravelDocumentArgs = {
  input: UserTravelDocumentInput;
};

export type MutationValidateCouponArgs = {
  input: CouponValidationInput;
};

/** Schema extension for myProfile aggregated query (merged at codegen time). */
export type MyProfile = {
  __typename?: 'MyProfile';
  basicPersonalInfoComplete: Scalars['Boolean']['output'];
  diveCertificate?: Maybe<DiveCertificate>;
  diveCertificateComplete: Scalars['Boolean']['output'];
  diveEquipment?: Maybe<DiveEquipment>;
  diveInsurance?: Maybe<DiveInsurance>;
  emergencyContact?: Maybe<UserEmergencyContact>;
  missingFields: Array<Scalars['String']['output']>;
  nextSection?: Maybe<Scalars['String']['output']>;
  readinessPercent: Scalars['Int']['output'];
  travelDocument?: Maybe<UserTravelDocument>;
  travelDocumentsComplete: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type Partner = {
  __typename?: 'Partner';
  kycState: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
};

export type PaymentIntentCreateInput = {
  boatId?: InputMaybe<Scalars['Int']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  isAuthenticated: Scalars['Boolean']['input'];
  roomIds: Array<PaymentIntentRoomInput>;
  tripId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentIntentResponse = {
  __typename?: 'PaymentIntentResponse';
  clientSecret: Scalars['String']['output'];
  discountApplied: Scalars['Long']['output'];
  paymentIntentId?: Scalars['String']['output'];
  totalAmount: Scalars['Long']['output'];
};

export type PaymentIntentRoomInput = {
  id: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  boat: Boat;
  boatFacilities: Array<BoatFacility>;
  boatPhotos: Array<BoatPhoto>;
  boats: Array<Boat>;
  bookingRooms: Array<BookingRoom>;
  countries: Array<Country>;
  countryLandingData?: Maybe<CountryLandingData>;
  couponDetails?: Maybe<Coupon>;
  diveCertificatesByUserId?: Maybe<DiveCertificate>;
  diveEquipmentByUserId?: Maybe<DiveEquipment>;
  diveInsuranceByUserId?: Maybe<DiveInsurance>;
  diveSites: Array<DiveSite>;
  emergencyContactsByUserId?: Maybe<UserEmergencyContact>;
  facilityGroups: Array<FacilityGroup>;
  isAdmin: Scalars['Boolean']['output'];
  mainRouteLandingData?: Maybe<MainRouteLandingData>;
  myBoats: Array<Boat>;
  myBookings: Array<UpcomingBookingSummary>;
  myPartner?: Maybe<Partner>;
  myProfile: MyProfile;
  myTrips: Array<Trip>;
  roomFacilities: Array<RoomFacility>;
  roomPhotos: Array<RoomPhoto>;
  roomTypes: Array<RoomType>;
  routeLandingData?: Maybe<RouteLandingData>;
  routeToMainRoutesByRouteIdList: Array<RouteToMainRoute>;
  routes: Array<Route>;
  singleTrip: Trip;
  topDestination: Array<Route>;
  travelDocumentUserId?: Maybe<UserTravelDocument>;
  trip: Array<FeatureTrip>;
  tripBenefits: Array<TripBenefit>;
  tripDetail: Trip;
  tripInvite: Array<TripInvite>;
  tripRoomAvailabilities: Array<TripRoomAvailability>;
  tripSkills: Array<Skill>;
  tripTransfer: TripTransfer;
  tripWithCriteria: Array<TripSearchResult>;
  upcomingBookingSummary: Array<UpcomingBookingSummary>;
  userByEmail?: Maybe<User>;
  userById?: Maybe<User>;
  validCoupons: Array<Coupon>;
};

export type QueryBoatArgs = {
  boatId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBoatFacilitiesArgs = {
  boatId: Scalars['Int']['input'];
  top: Scalars['Int']['input'];
};

export type QueryBoatPhotosArgs = {
  boatId?: InputMaybe<Scalars['Int']['input']>;
  boatSlug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBookingRoomsArgs = {
  bookingId: Scalars['Int']['input'];
};

export type QueryCountryLandingDataArgs = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCouponDetailsArgs = {
  code: Scalars['String']['input'];
};

export type QueryDiveCertificatesByUserIdArgs = {
  userId: Scalars['String']['input'];
};

export type QueryDiveEquipmentByUserIdArgs = {
  userId: Scalars['String']['input'];
};

export type QueryDiveInsuranceByUserIdArgs = {
  userId: Scalars['String']['input'];
};

export type QueryDiveSitesArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryEmergencyContactsByUserIdArgs = {
  userId: Scalars['String']['input'];
};

export type QueryMainRouteLandingDataArgs = {
  mainRouteId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRoomFacilitiesArgs = {
  roomId: Scalars['Int']['input'];
};

export type QueryRoomPhotosArgs = {
  roomId: Scalars['Int']['input'];
};

export type QueryRoomTypesArgs = {
  boatId: Scalars['Int']['input'];
  tripId: Scalars['Int']['input'];
};

export type QueryRouteLandingDataArgs = {
  routeId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRouteToMainRoutesByRouteIdListArgs = {
  routeIds: Array<Scalars['Int']['input']>;
};

export type QuerySingleTripArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryTravelDocumentUserIdArgs = {
  userId: Scalars['String']['input'];
};

export type QueryTripBenefitsArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryTripDetailArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryTripInviteArgs = {
  bookingId?: InputMaybe<Scalars['Int']['input']>;
  tripId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTripRoomAvailabilitiesArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryTripSkillsArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryTripTransferArgs = {
  tripId: Scalars['Int']['input'];
};

export type QueryTripWithCriteriaArgs = {
  request: TripSearchRequestInput;
};

export type QueryUpcomingBookingSummaryArgs = {
  userId: Scalars['String']['input'];
};

export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};

export type QueryUserByIdArgs = {
  userid: Scalars['String']['input'];
};

export type RentalGearItemInput = {
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
};

export type RoomAvailabilityUpdateInput = {
  availableRooms: Scalars['Int']['input'];
  roomId: Scalars['Int']['input'];
};

export type RoomDetailInput = {
  numberOfRooms: Scalars['Int']['input'];
  pricePerRoom: Scalars['Decimal']['input'];
  typeId: Scalars['Int']['input'];
};

export type RoomFacility = {
  __typename?: 'RoomFacility';
  facilityGroupId: Scalars['Int']['output'];
  facilityId: Scalars['Int']['output'];
  iconName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roomFacilityId: Scalars['Int']['output'];
  sort: Scalars['Int']['output'];
  typeId: Scalars['Int']['output'];
};

export type RoomPhoto = {
  __typename?: 'RoomPhoto';
  imageId: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isHero?: Maybe<Scalars['Boolean']['output']>;
  typeId: Scalars['Int']['output'];
};

export type RoomPriceUpdateInput = {
  price: Scalars['Decimal']['input'];
  typeId: Scalars['Int']['input'];
};

export type RoomType = {
  __typename?: 'RoomType';
  bedTypeId?: Maybe<Scalars['Int']['output']>;
  bedTypeName?: Maybe<Scalars['String']['output']>;
  boatId: Scalars['Int']['output'];
  deckLevelId?: Maybe<Scalars['Int']['output']>;
  deckLevelName?: Maybe<Scalars['String']['output']>;
  numberOfRooms: Scalars['Int']['output'];
  occupancy?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  roomFacilities?: Maybe<Array<RoomFacility>>;
  roomPhotos?: Maybe<Array<RoomPhoto>>;
  totalAvailable: Scalars['Int']['output'];
  typeId: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
};

export type Route = {
  __typename?: 'Route';
  countryId: Scalars['Int']['output'];
  isTopDestination: Scalars['Boolean']['output'];
  routeId: Scalars['Int']['output'];
  routeImageUrl?: Maybe<Scalars['String']['output']>;
  routeName: Scalars['String']['output'];
};

export type RouteLandingData = {
  __typename?: 'RouteLandingData';
  boats: Array<LandingBoatSummary>;
  countryId: Scalars['Int']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  departureCount: Scalars['Int']['output'];
  isTopDestination: Scalars['Boolean']['output'];
  maxPrice?: Maybe<Scalars['Decimal']['output']>;
  minPrice?: Maybe<Scalars['Decimal']['output']>;
  nextDepartureDate?: Maybe<Scalars['DateTime']['output']>;
  routeId: Scalars['Int']['output'];
  routeImageUrl?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
};

export type RouteLandingSummary = {
  __typename?: 'RouteLandingSummary';
  departureCount: Scalars['Int']['output'];
  isTopDestination: Scalars['Boolean']['output'];
  routeId: Scalars['Int']['output'];
  routeImageUrl?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
};

export type RouteToMainRoute = {
  __typename?: 'RouteToMainRoute';
  mainRouteId: Scalars['Int']['output'];
  mainRouteName?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['Int']['output'];
};

export type Skill = {
  __typename?: 'Skill';
  skillId: Scalars['Int']['output'];
  skillName: Scalars['String']['output'];
};

export type Trip = {
  __typename?: 'Trip';
  boatId: Scalars['Int']['output'];
  boatName?: Maybe<Scalars['String']['output']>;
  disembarkationDate: Scalars['DateTime']['output'];
  diveCount?: Maybe<Scalars['Int']['output']>;
  embarkationDate: Scalars['DateTime']['output'];
  organizerId: Scalars['Int']['output'];
  routeId: Scalars['Int']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['Int']['output'];
};

export type TripBenefit = {
  __typename?: 'TripBenefit';
  benefitId: Scalars['Int']['output'];
  benefitName: Scalars['String']['output'];
  benefitValue: Scalars['Int']['output'];
  isInclusion: Scalars['Boolean']['output'];
};

export type TripInvite = {
  __typename?: 'TripInvite';
  bookingId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  inviteId: Scalars['Int']['output'];
  inviteStatus: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  magicLink: Scalars['String']['output'];
  tripId: Scalars['Int']['output'];
};

export type TripRoomAvailability = {
  __typename?: 'TripRoomAvailability';
  availableRooms?: Maybe<Scalars['Int']['output']>;
  roomId: Scalars['Int']['output'];
  tripId: Scalars['Int']['output'];
};

export type TripSearchRequestInput = {
  destinationId: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  numberOfDiver: Scalars['Int']['input'];
  searchType: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type TripSearchResult = {
  __typename?: 'TripSearchResult';
  availabilityDetails: Array<AvailabilityDetail>;
  boatFacilities: Array<BoatFacility>;
  boatId: Scalars['Int']['output'];
  boatName?: Maybe<Scalars['String']['output']>;
  boatPhotos: Array<BoatPhoto>;
};

export type TripTransfer = {
  __typename?: 'TripTransfer';
  departureAirport: Scalars['Int']['output'];
  departureAirportCode?: Maybe<Scalars['String']['output']>;
  departureAirportName?: Maybe<Scalars['String']['output']>;
  departurePier: Scalars['Int']['output'];
  departurePierName?: Maybe<Scalars['String']['output']>;
  disembarkationTime: Scalars['DateTime']['output'];
  embarkationTime: Scalars['DateTime']['output'];
  returnAirport: Scalars['Int']['output'];
  returnAirportCode?: Maybe<Scalars['String']['output']>;
  returnAirportName?: Maybe<Scalars['String']['output']>;
  returnPier: Scalars['Int']['output'];
  returnPierName?: Maybe<Scalars['String']['output']>;
  transferId: Scalars['Int']['output'];
};

export type UpcomingBookingSummary = {
  __typename?: 'UpcomingBookingSummary';
  arrivalAirport?: Maybe<Scalars['String']['output']>;
  arrivalTime: Scalars['String']['output'];
  boatId: Scalars['Int']['output'];
  boatName: Scalars['String']['output'];
  boatPhoto: Scalars['String']['output'];
  boatSlug: Scalars['String']['output'];
  bookingId: Scalars['Int']['output'];
  bookingStatus: Scalars['Int']['output'];
  departureAirport?: Maybe<Scalars['String']['output']>;
  departurePier?: Maybe<Scalars['String']['output']>;
  departureTime: Scalars['String']['output'];
  disembarkationDate: Scalars['String']['output'];
  diveCount: Scalars['Int']['output'];
  embarkationDate: Scalars['String']['output'];
  guestCount: Scalars['Int']['output'];
  guestNumber: Scalars['Int']['output'];
  isLeadGuest: Scalars['Boolean']['output'];
  leadGuestEmail?: Maybe<Scalars['String']['output']>;
  leadGuestFullName?: Maybe<Scalars['String']['output']>;
  leadGuestPhone?: Maybe<Scalars['String']['output']>;
  returnPier?: Maybe<Scalars['String']['output']>;
  routeName: Scalars['String']['output'];
  tripId: Scalars['Int']['output'];
};

export type UpdateTripAvailabilityInput = {
  roomAvailabilities: Array<RoomAvailabilityUpdateInput>;
  tripId: Scalars['Int']['input'];
};

export type UpdateTripPricesInput = {
  roomPrices: Array<RoomPriceUpdateInput>;
  tripId: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  auth0Id?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  specialRequest?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type UserEmergencyContact = {
  __typename?: 'UserEmergencyContact';
  contactId: Scalars['Int']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserEmergencyContactInput = {
  contactId: Scalars['Int']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  specialRequest?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type UserTravelDocument = {
  __typename?: 'UserTravelDocument';
  countryOfIssuance?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['Int']['output'];
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserTravelDocumentInput = {
  countryOfIssuance?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['Int']['input'];
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  specialRequest?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type CreateBookingMutationVariables = Exact<{
  input: BookingCreateInput;
}>;

export type CreateBookingMutation = {
  __typename?: 'Mutation';
  createBooking: {
    __typename?: 'Booking';
    bookingId: number;
    tripId: number;
    bookingState: number;
  };
};

export type CreatePaymentIntentMutationVariables = Exact<{
  input: PaymentIntentCreateInput;
}>;

export type CreatePaymentIntentMutation = {
  __typename?: 'Mutation';
  createPaymentIntent: {
    __typename?: 'PaymentIntentResponse';
    clientSecret: string;
    totalAmount: any;
    discountApplied: any;
  };
};

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: boolean;
};

export type DeleteTripMutationVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type DeleteTripMutation = {
  __typename?: 'Mutation';
  deleteTrip: {
    __typename?: 'DeleteTripResponse';
    success: boolean;
    message?: string | null;
    errorCode?: string | null;
  };
};

export type DiveSitesByTripQueryVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type DiveSitesByTripQuery = {
  __typename?: 'Query';
  diveSites: Array<{
    __typename?: 'DiveSite';
    diveSiteId: number;
    siteName: string;
  }>;
};

export type BoatQueryVariables = Exact<{
  boatId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type BoatQuery = {
  __typename?: 'Query';
  boat: { __typename?: 'Boat'; boatId: number; name: string; currency: string };
};

export type BoatFacilitiesByBoatIdQueryVariables = Exact<{
  boatId: Scalars['Int']['input'];
  top: Scalars['Int']['input'];
}>;

export type BoatFacilitiesByBoatIdQuery = {
  __typename?: 'Query';
  boatFacilities: Array<{
    __typename?: 'BoatFacility';
    name: string;
    iconName?: string | null;
    facilityGroupId: number;
  }>;
};

export type BoatPhotosQueryVariables = Exact<{
  boatId?: InputMaybe<Scalars['Int']['input']>;
  boatSlug?: InputMaybe<Scalars['String']['input']>;
}>;

export type BoatPhotosQuery = {
  __typename?: 'Query';
  boatPhotos: Array<{
    __typename?: 'BoatPhoto';
    boatId: number;
    imageUrl: string;
    isHero?: boolean | null;
  }>;
};

export type RoomFacilitiesQueryVariables = Exact<{
  roomId: Scalars['Int']['input'];
}>;

export type RoomFacilitiesQuery = {
  __typename?: 'Query';
  roomFacilities: Array<{
    __typename?: 'RoomFacility';
    roomFacilityId: number;
    typeId: number;
    facilityId: number;
    name: string;
    facilityGroupId: number;
    sort: number;
    iconName?: string | null;
  }>;
};

export type RoomTypesQueryVariables = Exact<{
  boatId: Scalars['Int']['input'];
  tripId: Scalars['Int']['input'];
}>;

export type RoomTypesQuery = {
  __typename?: 'Query';
  roomTypes: Array<{
    __typename?: 'RoomType';
    typeId: number;
    typeName: string;
    boatId: number;
    numberOfRooms: number;
    bedTypeName?: string | null;
    deckLevelName?: string | null;
    occupancy?: number | null;
    price: number;
    totalAvailable: number;
    roomFacilities?: Array<{
      __typename?: 'RoomFacility';
      roomFacilityId: number;
      typeId: number;
      facilityId: number;
      name: string;
      facilityGroupId: number;
      sort: number;
      iconName?: string | null;
    }> | null;
    roomPhotos?: Array<{
      __typename?: 'RoomPhoto';
      imageId: number;
      imageUrl?: string | null;
      isHero?: boolean | null;
      typeId: number;
    }> | null;
  }>;
};

export type AllBoatsQueryVariables = Exact<{ [key: string]: never }>;

export type AllBoatsQuery = {
  __typename?: 'Query';
  boats: Array<{ __typename?: 'Boat'; boatId: number; name: string }>;
};

export type BookingRoomQueryVariables = Exact<{
  bookingId: Scalars['Int']['input'];
}>;

export type BookingRoomQuery = {
  __typename?: 'Query';
  bookingRooms: Array<{
    __typename?: 'BookingRoom';
    bookingId: number;
    typeId: number;
    numberOfRooms: number;
    pricePerRoom: number;
  }>;
};

export type AllCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type AllCountriesQuery = {
  __typename?: 'Query';
  countries: Array<{
    __typename?: 'Country';
    countryId: number;
    countryName: string;
  }>;
};

export type GetCountryLandingDataQueryVariables = Exact<{
  countryId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCountryLandingDataQuery = {
  __typename?: 'Query';
  countryLandingData?: {
    __typename?: 'CountryLandingData';
    countryId: number;
    countryName?: string | null;
    minPrice?: number | null;
    maxPrice?: number | null;
    currency?: string | null;
    departureCount: number;
    nextDepartureDate?: any | null;
    routes: Array<{
      __typename?: 'RouteLandingSummary';
      routeId: number;
      routeName?: string | null;
      routeImageUrl?: string | null;
      isTopDestination: boolean;
      departureCount: number;
    }>;
    boats: Array<{
      __typename?: 'LandingBoatSummary';
      boatId: number;
      name?: string | null;
      slug?: string | null;
      currency?: string | null;
      minPrice?: number | null;
      heroImageUrl?: string | null;
    }>;
  } | null;
};

export type DiveCertificatesByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type DiveCertificatesByUserIdQuery = {
  __typename?: 'Query';
  diveCertificatesByUserId?: {
    __typename?: 'DiveCertificate';
    certificateId: number;
    userId?: number | null;
    certificateLevel?: string | null;
    certifyingAgency?: string | null;
    certificateNumber?: string | null;
  } | null;
};

export type DiveEquipmentByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type DiveEquipmentByUserIdQuery = {
  __typename?: 'Query';
  diveEquipmentByUserId?: {
    __typename?: 'DiveEquipment';
    equipmentId: number;
    userId?: number | null;
    bcd?: string | null;
    wetsuit?: string | null;
    fins?: string | null;
  } | null;
};

export type DiveInsuranceByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type DiveInsuranceByUserIdQuery = {
  __typename?: 'Query';
  diveInsuranceByUserId?: {
    __typename?: 'DiveInsurance';
    insuranceId: number;
    userId?: number | null;
    policyNumber?: string | null;
  } | null;
};

export type EmergencyContactsByUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type EmergencyContactsByUserIdQuery = {
  __typename?: 'Query';
  emergencyContactsByUserId?: {
    __typename?: 'UserEmergencyContact';
    contactId: number;
    userId?: number | null;
    fullName?: string | null;
    phone?: string | null;
  } | null;
};

export type FacilityGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type FacilityGroupsQuery = {
  __typename?: 'Query';
  facilityGroups: Array<{
    __typename?: 'FacilityGroup';
    facilityGroupId: number;
    name: string;
  }>;
};

export type GetMainRouteLandingDataQueryVariables = Exact<{
  mainRouteId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMainRouteLandingDataQuery = {
  __typename?: 'Query';
  mainRouteLandingData?: {
    __typename?: 'MainRouteLandingData';
    mainRouteId: number;
    mainRouteName?: string | null;
    countryId: number;
    countryName?: string | null;
    routeImageUrl?: string | null;
    minPrice?: number | null;
    maxPrice?: number | null;
    currency?: string | null;
    departureCount: number;
    nextDepartureDate?: any | null;
    boats: Array<{
      __typename?: 'LandingBoatSummary';
      boatId: number;
      name?: string | null;
      slug?: string | null;
      currency?: string | null;
      minPrice?: number | null;
      heroImageUrl?: string | null;
    }>;
  } | null;
};

export type GetRouteLandingDataFallbackQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetRouteLandingDataFallbackQuery = {
  __typename?: 'Query';
  routeLandingData?: {
    __typename?: 'RouteLandingData';
    routeId: number;
    routeName?: string | null;
    countryId: number;
    countryName?: string | null;
    routeImageUrl?: string | null;
    minPrice?: number | null;
    maxPrice?: number | null;
    currency?: string | null;
    departureCount: number;
    nextDepartureDate?: any | null;
    boats: Array<{
      __typename?: 'LandingBoatSummary';
      boatId: number;
      name?: string | null;
      slug?: string | null;
      currency?: string | null;
      minPrice?: number | null;
      heroImageUrl?: string | null;
    }>;
  } | null;
};

export type MyPartnerQueryVariables = Exact<{ [key: string]: never }>;

export type MyPartnerQuery = {
  __typename?: 'Query';
  myPartner?: {
    __typename?: 'Partner';
    partnerId: number;
    name: string;
    status: string;
    kycState: string;
    stripeConnectAccountId?: string | null;
  } | null;
};

export type MyBoatsQueryVariables = Exact<{ [key: string]: never }>;

export type MyBoatsQuery = {
  __typename?: 'Query';
  myBoats: Array<{
    __typename?: 'Boat';
    boatId: number;
    name: string;
    slug: string;
    currency: string;
  }>;
};

export type MyBookingsQueryVariables = Exact<{ [key: string]: never }>;

export type MyBookingsQuery = {
  __typename?: 'Query';
  myBookings: Array<{
    __typename?: 'UpcomingBookingSummary';
    tripId: number;
    bookingId: number;
    boatId: number;
    boatPhoto: string;
    boatName: string;
    boatSlug: string;
    routeName: string;
    embarkationDate: string;
    disembarkationDate: string;
    guestCount: number;
    diveCount: number;
    arrivalAirport?: string | null;
    arrivalTime: string;
    departureAirport?: string | null;
    departureTime: string;
    departurePier?: string | null;
    returnPier?: string | null;
    bookingStatus: number;
    isLeadGuest: boolean;
    guestNumber: number;
    leadGuestFullName?: string | null;
    leadGuestEmail?: string | null;
    leadGuestPhone?: string | null;
  }>;
};

export type MyTripsQueryVariables = Exact<{ [key: string]: never }>;

export type MyTripsQuery = {
  __typename?: 'Query';
  myTrips: Array<{
    __typename?: 'Trip';
    tripId: number;
    routeId: number;
    embarkationDate: any;
    disembarkationDate: any;
    boatId: number;
    organizerId: number;
    routeName?: string | null;
    boatName?: string | null;
    diveCount?: number | null;
  }>;
};

export type GetRouteLandingDataQueryVariables = Exact<{
  routeId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetRouteLandingDataQuery = {
  __typename?: 'Query';
  routeLandingData?: {
    __typename?: 'RouteLandingData';
    routeId: number;
    routeName?: string | null;
    countryId: number;
    countryName?: string | null;
    routeImageUrl?: string | null;
    isTopDestination: boolean;
    minPrice?: number | null;
    maxPrice?: number | null;
    currency?: string | null;
    departureCount: number;
    nextDepartureDate?: any | null;
    boats: Array<{
      __typename?: 'LandingBoatSummary';
      boatId: number;
      name?: string | null;
      slug?: string | null;
      currency?: string | null;
      minPrice?: number | null;
      heroImageUrl?: string | null;
    }>;
  } | null;
};

export type AllRoutesQueryVariables = Exact<{ [key: string]: never }>;

export type AllRoutesQuery = {
  __typename?: 'Query';
  routes: Array<{
    __typename?: 'Route';
    routeId: number;
    routeName: string;
    countryId: number;
    isTopDestination: boolean;
  }>;
};

export type GetSearchResultQueryVariables = Exact<{
  destinationId: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  numberOfDiver: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  searchType: Scalars['Int']['input'];
}>;

export type GetSearchResultQuery = {
  __typename?: 'Query';
  tripWithCriteria: Array<{
    __typename?: 'TripSearchResult';
    boatId: number;
    boatName?: string | null;
    availabilityDetails: Array<{
      __typename?: 'AvailabilityDetail';
      routeName: string;
      embarkationDate: string;
      disEmbarkationDate: string;
      price: number;
      currency: string;
      numberOfDay: number;
      numberOfNight: number;
      numberOfDive: number;
      tripId: number;
      routeId: number;
      totalAvailability: number;
    }>;
    boatFacilities: Array<{
      __typename?: 'BoatFacility';
      boatId: number;
      name: string;
      sort: number;
      facilityGroupId: number;
      iconName?: string | null;
    }>;
    boatPhotos: Array<{
      __typename?: 'BoatPhoto';
      boatId: number;
      imageUrl: string;
    }>;
  }>;
};

export type SingleTripQueryVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type SingleTripQuery = {
  __typename?: 'Query';
  singleTrip: {
    __typename?: 'Trip';
    tripId: number;
    boatId: number;
    disembarkationDate: any;
    embarkationDate: any;
  };
};

export type TripBenefitsQueryVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type TripBenefitsQuery = {
  __typename?: 'Query';
  tripBenefits: Array<{
    __typename?: 'TripBenefit';
    benefitId: number;
    benefitName: string;
    benefitValue: number;
    isInclusion: boolean;
  }>;
};

export type TripTransferQueryVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type TripTransferQuery = {
  __typename?: 'Query';
  tripTransfer: {
    __typename?: 'TripTransfer';
    embarkationTime: any;
    disembarkationTime: any;
    returnAirportName?: string | null;
    returnAirportCode?: string | null;
    departureAirportName?: string | null;
    departureAirportCode?: string | null;
    returnPierName?: string | null;
    departurePierName?: string | null;
  };
};

export type UserByIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type UserByIdQuery = {
  __typename?: 'Query';
  userById?: {
    __typename?: 'User';
    userId: number;
    auth0Id?: string | null;
    email: string;
    fullName: string;
    gender?: string | null;
    phone?: string | null;
    dateOfBirth?: string | null;
    specialRequest?: string | null;
  } | null;
};

export type IsAdminQueryVariables = Exact<{ [key: string]: never }>;

export type IsAdminQuery = { __typename?: 'Query'; isAdmin: boolean };

export type MyProfileQueryVariables = Exact<{ [key: string]: never }>;

export type MyProfileQuery = {
  __typename?: 'Query';
  myProfile: {
    __typename?: 'MyProfile';
    readinessPercent: number;
    basicPersonalInfoComplete: boolean;
    travelDocumentsComplete: boolean;
    diveCertificateComplete: boolean;
    missingFields: Array<string>;
    nextSection?: string | null;
    user?: {
      __typename?: 'User';
      userId: number;
      auth0Id?: string | null;
      email: string;
      fullName: string;
      gender?: string | null;
      phone?: string | null;
      dateOfBirth?: string | null;
      specialRequest?: string | null;
    } | null;
    travelDocument?: {
      __typename?: 'UserTravelDocument';
      documentId: number;
      countryOfIssuance?: string | null;
      passportNumber?: string | null;
      expiryDate?: any | null;
    } | null;
    emergencyContact?: {
      __typename?: 'UserEmergencyContact';
      contactId: number;
      fullName?: string | null;
      phone?: string | null;
    } | null;
    diveCertificate?: {
      __typename?: 'DiveCertificate';
      certificateId: number;
      certificateLevel?: string | null;
      certifyingAgency?: string | null;
      certificateNumber?: string | null;
    } | null;
    diveEquipment?: {
      __typename?: 'DiveEquipment';
      equipmentId: number;
      bcd?: string | null;
      wetsuit?: string | null;
      fins?: string | null;
    } | null;
    diveInsurance?: {
      __typename?: 'DiveInsurance';
      insuranceId: number;
      policyNumber?: string | null;
    } | null;
  };
};

export type RouteToMainRoutesByRouteIdListQueryVariables = Exact<{
  routeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RouteToMainRoutesByRouteIdListQuery = {
  __typename?: 'Query';
  routeToMainRoutesByRouteIdList: Array<{
    __typename?: 'RouteToMainRoute';
    routeId: number;
    mainRouteId: number;
    mainRouteName?: string | null;
  }>;
};

export type SendTripManagementInvitationMutationVariables = Exact<{
  bookingId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
  guestNumber: Scalars['Int']['input'];
  guestEmail: Scalars['String']['input'];
}>;

export type SendTripManagementInvitationMutation = {
  __typename?: 'Mutation';
  tripInvite: boolean;
};

export type TopDestinationQueryVariables = Exact<{ [key: string]: never }>;

export type TopDestinationQuery = {
  __typename?: 'Query';
  topDestination: Array<{
    __typename?: 'Route';
    routeId: number;
    routeName: string;
    countryId: number;
    routeImageUrl?: string | null;
  }>;
};

export type TravelDocumentUserIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type TravelDocumentUserIdQuery = {
  __typename?: 'Query';
  travelDocumentUserId?: {
    __typename?: 'UserTravelDocument';
    documentId: number;
    userId?: number | null;
    countryOfIssuance?: string | null;
    expiryDate?: any | null;
    passportNumber?: string | null;
  } | null;
};

export type GetTripDetailsQueryVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type GetTripDetailsQuery = {
  __typename?: 'Query';
  tripDetail: {
    __typename?: 'Trip';
    tripId: number;
    routeId: number;
    embarkationDate: any;
    disembarkationDate: any;
    boatId: number;
    organizerId: number;
    routeName?: string | null;
    boatName?: string | null;
    diveCount?: number | null;
  };
};

export type TripInvitesByTripOrBookingQueryVariables = Exact<{
  tripId?: InputMaybe<Scalars['Int']['input']>;
  bookingId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TripInvitesByTripOrBookingQuery = {
  __typename?: 'Query';
  tripInvite: Array<{
    __typename?: 'TripInvite';
    inviteId: number;
    tripId: number;
    bookingId: number;
    email: string;
    magicLink: string;
    isCompleted: boolean;
    inviteStatus: number;
  }>;
};

export type TripSkillsByTripQueryVariables = Exact<{
  tripId: Scalars['Int']['input'];
}>;

export type TripSkillsByTripQuery = {
  __typename?: 'Query';
  tripSkills: Array<{
    __typename?: 'Skill';
    skillId: number;
    skillName: string;
  }>;
};

export type UpcomingBookingSummaryQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type UpcomingBookingSummaryQuery = {
  __typename?: 'Query';
  upcomingBookingSummary: Array<{
    __typename?: 'UpcomingBookingSummary';
    arrivalAirport?: string | null;
    arrivalTime: string;
    boatName: string;
    boatPhoto: string;
    departureAirport?: string | null;
    departurePier?: string | null;
    departureTime: string;
    disembarkationDate: string;
    diveCount: number;
    embarkationDate: string;
    guestCount: number;
    returnPier?: string | null;
    routeName: string;
    tripId: number;
    bookingStatus: number;
    bookingId: number;
    boatSlug: string;
    boatId: number;
    isLeadGuest: boolean;
    guestNumber: number;
  }>;
};

export type UpdateTripAvailabilityMutationVariables = Exact<{
  input: UpdateTripAvailabilityInput;
}>;

export type UpdateTripAvailabilityMutation = {
  __typename?: 'Mutation';
  updateTripAvailability: boolean;
};

export type UpdateTripPricesMutationVariables = Exact<{
  input: UpdateTripPricesInput;
}>;

export type UpdateTripPricesMutation = {
  __typename?: 'Mutation';
  updateTripPrices: boolean;
};

export type UpdateUserMutationVariables = Exact<{
  user: UserUpdateInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: boolean;
};

export type UpsertDiveCertificationMutationVariables = Exact<{
  input: DiveCertificateInput;
}>;

export type UpsertDiveCertificationMutation = {
  __typename?: 'Mutation';
  upsertDiveCertification: boolean;
};

export type UpsertDiveEquipmentMutationVariables = Exact<{
  input: DiveEquipmentInput;
}>;

export type UpsertDiveEquipmentMutation = {
  __typename?: 'Mutation';
  upsertDiveEquipment: boolean;
};

export type UpsertDiveInsuranceMutationVariables = Exact<{
  input: DiveInsuranceInput;
}>;

export type UpsertDiveInsuranceMutation = {
  __typename?: 'Mutation';
  upsertDiveInsurance: boolean;
};

export type UpsertEmergencyContactMutationVariables = Exact<{
  input: UserEmergencyContactInput;
}>;

export type UpsertEmergencyContactMutation = {
  __typename?: 'Mutation';
  upsertEmergencyContact: boolean;
};

export type GuestDetailMutationVariables = Exact<{
  input: GuestDetailsInput;
}>;

export type GuestDetailMutation = {
  __typename?: 'Mutation';
  guestDetail: boolean;
};

export type UpsertTravelDocumentMutationVariables = Exact<{
  input: UserTravelDocumentInput;
}>;

export type UpsertTravelDocumentMutation = {
  __typename?: 'Mutation';
  upsertTravelDocument: boolean;
};

export type ValidateCouponMutationVariables = Exact<{
  input: CouponValidationInput;
}>;

export type ValidateCouponMutation = {
  __typename?: 'Mutation';
  validateCoupon: {
    __typename?: 'CouponValidationResult';
    isValid: boolean;
    discountType?: string | null;
    discountValue?: number | null;
    discountAmount?: number | null;
    newTotalAmount?: number | null;
    message: string;
  };
};

export type AllFeatureTripQueryQueryVariables = Exact<{ [key: string]: never }>;

export type AllFeatureTripQueryQuery = {
  __typename?: 'Query';
  trip: Array<{
    __typename?: 'FeatureTrip';
    tripId: number;
    routeId: number;
    embarkationDate: string;
    disembarkationDate: string;
    numberOfDays: number;
    numberOfNights: number;
    diveCount: number;
    price: number;
    imageUrl: string;
    currency: string;
    organizerId: number;
    routeName: string;
    boatName: string;
    boatId: number;
  }>;
};

export const CreateBookingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createBooking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BookingCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBooking' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bookingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookingState' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateBookingMutation,
  CreateBookingMutationVariables
>;
export const CreatePaymentIntentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPaymentIntent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PaymentIntentCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaymentIntent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientSecret' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAmount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountApplied' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePaymentIntentMutation,
  CreatePaymentIntentMutationVariables
>;
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'user' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteTripDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteTrip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTrip' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorCode' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTripMutation, DeleteTripMutationVariables>;
export const DiveSitesByTripDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'diveSitesByTrip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diveSites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'diveSiteId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiveSitesByTripQuery,
  DiveSitesByTripQueryVariables
>;
export const BoatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'boat' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boatId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'boatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boatId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoatQuery, BoatQueryVariables>;
export const BoatFacilitiesByBoatIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'boatFacilitiesByBoatId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boatId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'top' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boatFacilities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'boatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boatId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'top' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'top' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facilityGroupId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BoatFacilitiesByBoatIdQuery,
  BoatFacilitiesByBoatIdQueryVariables
>;
export const BoatPhotosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'boatPhotos' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boatId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boatSlug' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boatPhotos' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'boatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boatId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'boatSlug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boatSlug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isHero' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BoatPhotosQuery, BoatPhotosQueryVariables>;
export const RoomFacilitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'roomFacilities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'roomId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roomFacilities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roomId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'roomId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roomFacilityId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'facilityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facilityGroupId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomFacilitiesQuery, RoomFacilitiesQueryVariables>;
export const RoomTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'roomTypes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boatId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roomTypes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'boatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'boatId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfRooms' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bedTypeName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deckLevelName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'occupancy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalAvailable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roomFacilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roomFacilityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'typeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facilityId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facilityGroupId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roomPhotos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isHero' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'typeId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoomTypesQuery, RoomTypesQueryVariables>;
export const AllBoatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allBoats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllBoatsQuery, AllBoatsQueryVariables>;
export const BookingRoomDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'bookingRoom' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bookingId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingRooms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bookingId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bookingId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'bookingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfRooms' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pricePerRoom' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookingRoomQuery, BookingRoomQueryVariables>;
export const AllCountriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allCountries' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllCountriesQuery, AllCountriesQueryVariables>;
export const GetCountryLandingDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCountryLandingData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryLandingData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countryId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextDepartureDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeImageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isTopDestination' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'departureCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boatId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCountryLandingDataQuery,
  GetCountryLandingDataQueryVariables
>;
export const DiveCertificatesByUserIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'diveCertificatesByUserId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diveCertificatesByUserId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certificateId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certificateLevel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certifyingAgency' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certificateNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiveCertificatesByUserIdQuery,
  DiveCertificatesByUserIdQueryVariables
>;
export const DiveEquipmentByUserIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'diveEquipmentByUserId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diveEquipmentByUserId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'equipmentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bcd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'wetsuit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fins' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiveEquipmentByUserIdQuery,
  DiveEquipmentByUserIdQueryVariables
>;
export const DiveInsuranceByUserIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'diveInsuranceByUserId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'diveInsuranceByUserId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'insuranceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policyNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiveInsuranceByUserIdQuery,
  DiveInsuranceByUserIdQueryVariables
>;
export const EmergencyContactsByUserIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'emergencyContactsByUserId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emergencyContactsByUserId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'contactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmergencyContactsByUserIdQuery,
  EmergencyContactsByUserIdQueryVariables
>;
export const FacilityGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'facilityGroups' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facilityGroups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facilityGroupId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FacilityGroupsQuery, FacilityGroupsQueryVariables>;
export const GetMainRouteLandingDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMainRouteLandingData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'mainRouteId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mainRouteLandingData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mainRouteId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'mainRouteId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'mainRouteId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainRouteName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeImageUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextDepartureDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boatId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMainRouteLandingDataQuery,
  GetMainRouteLandingDataQueryVariables
>;
export const GetRouteLandingDataFallbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRouteLandingDataFallback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeLandingData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeImageUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextDepartureDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boatId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRouteLandingDataFallbackQuery,
  GetRouteLandingDataFallbackQueryVariables
>;
export const MyPartnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myPartner' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPartner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'partnerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kycState' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeConnectAccountId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyPartnerQuery, MyPartnerQueryVariables>;
export const MyBoatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myBoats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myBoats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyBoatsQuery, MyBoatsQueryVariables>;
export const MyBookingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myBookings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myBookings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatPhoto' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatSlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'guestCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diveCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrivalAirport' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'arrivalTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureAirport' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departurePier' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookingStatus' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isLeadGuest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadGuestFullName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadGuestEmail' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadGuestPhone' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyBookingsQuery, MyBookingsQueryVariables>;
export const MyTripsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myTrips' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myTrips' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diveCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyTripsQuery, MyTripsQueryVariables>;
export const GetRouteLandingDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRouteLandingData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'routeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeLandingData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'routeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'routeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeImageUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTopDestination' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextDepartureDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boatId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRouteLandingDataQuery,
  GetRouteLandingDataQueryVariables
>;
export const AllRoutesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allRoutes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTopDestination' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllRoutesQuery, AllRoutesQueryVariables>;
export const GetSearchResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSearchResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'destinationId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'month' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfDiver' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchType' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripWithCriteria' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'request' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'destinationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'destinationId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'month' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'month' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'numberOfDiver' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'numberOfDiver' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'year' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'year' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'searchType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'searchType' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availabilityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'embarkationDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'disEmbarkationDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfDay' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfNight' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfDive' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tripId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalAvailability' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boatFacilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boatId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facilityGroupId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'boatPhotos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boatId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSearchResultQuery,
  GetSearchResultQueryVariables
>;
export const SingleTripDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'singleTrip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'singleTrip' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationDate' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SingleTripQuery, SingleTripQueryVariables>;
export const TripBenefitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tripBenefits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripBenefits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'benefitId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'benefitName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'benefitValue' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isInclusion' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TripBenefitsQuery, TripBenefitsQueryVariables>;
export const TripTransferDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tripTransfer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripTransfer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnAirportName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnAirportCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureAirportName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureAirportCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returnPierName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departurePierName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TripTransferQuery, TripTransferQueryVariables>;
export const UserByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auth0Id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'specialRequest' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserByIdQuery, UserByIdQueryVariables>;
export const IsAdminDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'isAdmin' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsAdminQuery, IsAdminQueryVariables>;
export const MyProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myProfile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auth0Id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dateOfBirth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'specialRequest' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelDocument' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countryOfIssuance' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiryDate' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emergencyContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'diveCertificate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'certificateId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'certificateLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'certifyingAgency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'certificateNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'diveEquipment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'equipmentId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bcd' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wetsuit' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fins' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'diveInsurance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insuranceId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policyNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'readinessPercent' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'basicPersonalInfoComplete' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelDocumentsComplete' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'diveCertificateComplete' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'missingFields' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nextSection' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyProfileQuery, MyProfileQueryVariables>;
export const RouteToMainRoutesByRouteIdListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'routeToMainRoutesByRouteIdList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'routeIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'Int' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routeToMainRoutesByRouteIdList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'routeIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'routeIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainRouteId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainRouteName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RouteToMainRoutesByRouteIdListQuery,
  RouteToMainRoutesByRouteIdListQueryVariables
>;
export const SendTripManagementInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendTripManagementInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bookingId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'guestNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'guestEmail' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bookingId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bookingId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'guestNumber' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'guestNumber' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'guestEmail' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'guestEmail' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendTripManagementInvitationMutation,
  SendTripManagementInvitationMutationVariables
>;
export const TopDestinationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'topDestination' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'topDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeImageUrl' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopDestinationQuery, TopDestinationQueryVariables>;
export const TravelDocumentUserIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'travelDocumentUserId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelDocumentUserId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOfIssuance' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'passportNumber' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TravelDocumentUserIdQuery,
  TravelDocumentUserIdQueryVariables
>;
export const GetTripDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTripDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diveCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTripDetailsQuery, GetTripDetailsQueryVariables>;
export const TripInvitesByTripOrBookingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tripInvitesByTripOrBooking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bookingId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'bookingId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'bookingId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'inviteId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bookingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'magicLink' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCompleted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inviteStatus' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TripInvitesByTripOrBookingQuery,
  TripInvitesByTripOrBookingQueryVariables
>;
export const TripSkillsByTripDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tripSkillsByTrip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tripId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripSkills' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tripId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tripId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'skillId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skillName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TripSkillsByTripQuery,
  TripSkillsByTripQueryVariables
>;
export const UpcomingBookingSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'upcomingBookingSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upcomingBookingSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'userId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'arrivalAirport' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'arrivalTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatPhoto' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureAirport' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departurePier' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'departureTime' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'diveCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'guestCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'returnPier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookingStatus' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bookingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatSlug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLeadGuest' } },
                { kind: 'Field', name: { kind: 'Name', value: 'guestNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpcomingBookingSummaryQuery,
  UpcomingBookingSummaryQueryVariables
>;
export const UpdateTripAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTripAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTripAvailabilityInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTripAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTripAvailabilityMutation,
  UpdateTripAvailabilityMutationVariables
>;
export const UpdateTripPricesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTripPrices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateTripPricesInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTripPrices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTripPricesMutation,
  UpdateTripPricesMutationVariables
>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'user' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpsertDiveCertificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertDiveCertification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DiveCertificateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertDiveCertification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertDiveCertificationMutation,
  UpsertDiveCertificationMutationVariables
>;
export const UpsertDiveEquipmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertDiveEquipment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DiveEquipmentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertDiveEquipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertDiveEquipmentMutation,
  UpsertDiveEquipmentMutationVariables
>;
export const UpsertDiveInsuranceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertDiveInsurance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DiveInsuranceInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertDiveInsurance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertDiveInsuranceMutation,
  UpsertDiveInsuranceMutationVariables
>;
export const UpsertEmergencyContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertEmergencyContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserEmergencyContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertEmergencyContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertEmergencyContactMutation,
  UpsertEmergencyContactMutationVariables
>;
export const GuestDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'guestDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GuestDetailsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'guestDetails' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GuestDetailMutation, GuestDetailMutationVariables>;
export const UpsertTravelDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'upsertTravelDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserTravelDocumentInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertTravelDocument' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertTravelDocumentMutation,
  UpsertTravelDocumentMutationVariables
>;
export const ValidateCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'validateCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CouponValidationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isValid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountValue' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountAmount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'newTotalAmount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateCouponMutation,
  ValidateCouponMutationVariables
>;
export const AllFeatureTripQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allFeatureTripQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trip' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'tripId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'embarkationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disembarkationDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfDays' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfNights' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'diveCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'organizerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'routeName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'boatId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllFeatureTripQueryQuery,
  AllFeatureTripQueryQueryVariables
>;
